module.exports = __webpack_public_path__ + "static/media/kg.5908392a.svg";